import { store } from 'quasar/wrappers'
import { createStore } from 'vuex'

import apis from './modules/apis'
import auth from './modules/auth'
import subscription from './modules/subscription'
import tenant from './modules/tenant'
import theme from './modules/theme'
import pwa from './modules/pwa'

// declare module '@vue/runtime-core' {
//   // declare your own store states
//   interface State {
//   }

//   // provide typings for `this.$store`
//   interface ComponentCustomProperties {
//     $store: Store<State>
//   }
// }

export default store((/* { ssrContext } */) => {
  const Store = createStore({
    modules: {
      apis,
      auth,
      subscription,
      tenant,
      pwa,
      theme,
    },

    // enable strict mode (adds overhead!)
    // for dev mode and --debug builds only
    strict: Boolean(process.env.DEBUGGING),
  })

  return Store
})
